@if (content) {
<nb-card>
  <nb-card-body>
    <div class="ql-container ql-snow ngx-quill-view-html" style="border: none">
      <div class="ql-editor" [innerHTML]="content"></div>
    </div>
  </nb-card-body>
</nb-card>
} @if (!content) {
<nb-alert translate="tenantLinks.linkEmpty"> </nb-alert>
}
